import React from "react";
import { observer } from "mobx-react-lite";
import { makeStyles } from '@material-ui/core/styles';
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
    whiteColor: {
        color: "white"
    },
    staticHelpBlock: {
        marginTop: theme.spacing(2),
        "& p": { marginBottom: theme.spacing(1.5) }
    },
    staticHelpLink: {
        color: theme.palette.primary.main
    }
}));

export default observer(function Help() {
    const classes = useStyles();

    return (
        <div className={classes.whiteColor}>
            <Typography variant="h5">How can we help?</Typography>
            <div className={classes.staticHelpBlock}>
                <Typography variant="body1">
                    Email us at:{" "}
                    <a href="mailto:support@starfishperks.com" className={classes.staticHelpLink}>
                        support@starfishperks.com
                    </a>
                </Typography>
                <Typography variant="body1">
                    Customer Service Hours: Monday – Friday: 8:30 AM – 5:00 PM EST
                </Typography>
                <Typography variant="body1">
                    You are important to us, and we'll respond to you within 24 business hours.
                </Typography>
                <Typography variant="body1" style={{ marginTop: 24 }}>
                    Thank you,
                </Typography>
                <Typography variant="body1">
                    Starfish Customer Support
                </Typography>
            </div>
        </div>
    );
});
